// TOP-LEVEL IMPORTS
import React, { PureComponent } from 'react';
import styled from 'styled-components';
// MEDIA
import loader from 'lib/media/loader.svg';

// STYLED-COMPONENTS
// =========================
const Loading = styled.div`
  font-size: 16px;
  text-align: center;
  color: white;
  opacity: 0.6;
  height: 200px;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  img {
    height: 26px;
    width: 26px;
    margin: 16px auto;
    display: block;
  }
`;

// EXPORTED COMPONENT
// =========================
class LoadingState extends PureComponent {
  render() {
    return (
      <div style={{ height: '100%', minHeight: 200 }}>
        <Loading>
          {this.props.lottieloader ? (
            this.props.lottieloader()
          ) : (
            <img src={loader} alt="Loading..." />
          )}
          {this.props.message}
        </Loading>
      </div>
    );
  }
}

// PROPS
// =========================
LoadingState.defaultProps = {
  message: ' Loading...',
};

// EXPORT
// =========================
export default LoadingState;



// WEBPACK FOOTER //
// ./src/components/common/LoadingState/index.js